<template>
  <div>
    <v-card class="mx-auto my-4" max-width="450" v-if="token">
      <v-card-title> Set new password </v-card-title>
      <v-card-text>
        Please set your new password:
        <v-form ref="refPasswords" @submit.prevent="doPasswordReset">
          <v-text-field
            v-model="newPassword"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show1 ? 'text' : 'password'"
            label="New password"
            class="input-group--focused"
            hint="At least 6 characters"
            :rules="[
              (v) => !!v || 'Password is required',
              (v) =>
                (v && v.length >= 6) ||
                'Password must be at least 6 characters',
            ]"
            @click:append="show1 = !show1"
          >
          </v-text-field>
          <v-text-field
            v-model="newPasswordConfirm"
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show2 ? 'text' : 'password'"
            label="Confirm new password"
            class="input-group--focused"
            :rules="[
              (v) => !!v || 'Password confirmation is required',
              (v) => v === newPassword || 'Passwords do not match',
            ]"
            @click:append="show2 = !show2"
          >
          </v-text-field>
          <span class="red--text ma-0 sa-0">{{ errorMsgSetNew }}</span>
          <div class="d-flex justify-center mb-2 mt-2">
            <v-btn
              block
              large
              color="primary"
              :loading="btnLoading"
              type="submit"
              @click="doPasswordReset"
            >
              Send
            </v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card
      class="mx-auto my-4"
      max-width="450"
      v-if="!token && confirmationMsg"
    >
      <v-card-title> Check your email </v-card-title>
      <v-card-text>
        Thanks! If <b> {{ userEmail }} </b> matches an email we have on file,
        then we've sent you an email containing further instructions for
        resetting your password.
        <div class="d-flex justify-space-between mt-4">
          <div>
            <span>Get back to </span>
            <a href="/login" class="text-decoration-none font-weight-medium">
              login.
            </a>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-card
      class="mx-auto my-4"
      max-width="450"
      v-if="!token && !confirmationMsg"
    >
      <v-card-title> Password reset </v-card-title>
      <v-card-text>
        Enter the email address associated with your account and we'll send you
        a link to reset your password.
        <v-form @submit.prevent="passwordReset">
          <v-text-field
            class="mt-3"
            v-model="userEmail"
            label="Email"
            type="email"
            required
          >
          </v-text-field>
          <div class="d-flex justify-center mb-2 mt-4">
            <v-btn
              block
              large
              color="primary"
              :loading="btnLoading"
              :disabled="btnLoading"
              type="submit"
              @click="sendPasswordReset"
            >
              Continue
            </v-btn>
          </div>
          <div class="d-flex justify-space-between mt-4">
            <div>
              <span>Get back to </span>
              <a href="/login" class="text-decoration-none font-weight-medium">
                login.
              </a>
              <span> Don't have account yet? Follow here to </span>
              <a
                href="/register"
                class="text-decoration-none font-weight-medium"
              >
                register.
              </a>
            </div>
          </div>
          <span class="red--text ma-0 sa-0">{{ errorMsg }}</span>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userEmail: "",
      btnLoading: false,
      errorMsg: "",
      confirmationMsg: false,
      token: "",
      show1: false,
      show2: false,
      newPassword: "",
      newPasswordConfirm: "",
      errorMsgSetNew: "",
    };
  },
  mounted() {
    this.$utils.visit(this);
    this.userEmail = this.$route.query.email || "";
    this.token = this.$route.query.token;
    console.log("token: " + this.token);
  },
  methods: {
    async sendPasswordReset() {
      try {
        this.btnLoading = true;
        await this.$utils.callBackendPost(this, "/pub/resetPassword", {
          email: this.userEmail,
        });
      } catch (error) {
        console.log("sendPasswordReset error: " + error);
      } finally {
        this.btnLoading = false;
        this.confirmationMsg = true;
      }
    },
    async doPasswordReset() {
      if (!this.$refs.refPasswords.validate()) {
        return;
      }
      this.btnLoading = true;
      this.errorMsgSetNew = "";
      try {
        await this.$utils.callBackendPost(this, "/pub/resetPassword", {
          token: this.token,
          newPassword: this.newPassword,
        });
        this.$router.push("/login?msg=passwordResetSuccess");
      } catch (error) {
        this.errorMsgSetNew = error;
      } finally {
        this.btnLoading = false;
      }
    },
  },
};
</script>

<style></style>
